import React from 'react';
import cx from 'classnames';

import styles from './integrationConfirmView.module.scss';
// import { localizedStrings } from 'src/constants/localization';
import { localizedStrings } from 'src/localization/index.jsx';

class IntegrationValidateView extends React.Component {
  constructor(props) {
    super(props);

    this._handleCancelClick = this._handleCancelClick.bind(this);

    this.localizedIntegrations = localizedStrings.components.integrations;
  }

  _handlUpdateClick() {
    this.props.updateStreamsAccess(this.props.account).then(() => {
      this.props.onUpdate();
    })
  }

  _handleCancelClick() {
    this.props.onCancel();
  }

  render() {
    return (
      <div className={styles.content}>
        <div className={styles.left}>
          <div className={styles.column}>
            <span className={cx('paperflite-close', styles.closeButton)} onClick={this._handleCancelClick}></span>
            <h1>{ this.localizedIntegrations.integration }</h1>
            <p className={styles.subHeading}>{ this.localizedIntegrations.conflict.title }</p>
            <p className={styles.description}>
              {localizedStrings.formatString(this.localizedIntegrations.conflict.sub_text,
                {
                  name: this.renderServiceName(this.props.activatedIntegration.category.name),
                  activatedName: this.renderServiceName(this.props.activatedIntegration.type),
                  integrationName: this.renderServiceName(this.props.activatedIntegration.type),
                  serviceName: this.props.clickedIntegration.productCapabilityResponse.name
                })}
            </p>
          </div>
        </div>
      </div>
    )
  }

  renderServiceName(name) {
    return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase()
  }
}

export default IntegrationValidateView;